import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Up: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-2-up, align top"} maskId="square-filled-radius-0-stroke-1-IconArrowWall2Up"><path fillRule="evenodd" clipRule="evenodd" d="M4 3H20V4H12.2071L17.4571 9.25L16.75 9.95711L12.5 5.7071V21H11.5V5.70711L7.25 9.95711L6.54289 9.25L11.7929 4H4V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWall2Up;
